import {MolecularGraph} from "../../graph/MolecularGraph"
import {rxrExtractor} from "./rxrExtractor";
import {Features} from "../../feature";

export const sulfideExtractor = {
    extract: (graph: MolecularGraph) => rxrExtractor.extract("S", Features.sulfide, graph)
}
